import { render, staticRenderFns } from "./RecipientInfo.vue?vue&type=template&id=2af71143&scoped=true"
import script from "./RecipientInfo.vue?vue&type=script&lang=js"
export * from "./RecipientInfo.vue?vue&type=script&lang=js"
import style0 from "./RecipientInfo.vue?vue&type=style&index=0&id=2af71143&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af71143",
  null
  
)

export default component.exports